module.exports = __webpack_public_path__ + "e57c591213bb1fe7a61c169d30613f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = 582
// module chunks = 4